import { render, staticRenderFns } from "./Hockey.vue?vue&type=template&id=41ed5603&scoped=true"
import script from "./Hockey.vue?vue&type=script&lang=js"
export * from "./Hockey.vue?vue&type=script&lang=js"
import style0 from "./Hockey.vue?vue&type=style&index=0&id=41ed5603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed5603",
  null
  
)

export default component.exports